import type { FC } from 'react';
import { ProgramList } from './components/ProgramList';
import { Gallery } from './components/Gallery';

export interface IslandProps {
  dataset: Record<string, string | undefined>;
  settings: Record<string, unknown>;
}

// Add an island by: (a) drop <div data-react="x"> in Twig, (b) register x here.
export const REGISTRY: Record<string, FC<IslandProps>> = {
  program: ProgramList,
  gallery: Gallery,
  // hamburger: Hamburger,
  // footer: Footer,
};
